import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const SearchIcon = ({ color = '#fff', size = 20, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 23 22"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m21.571 17.337-3.634-3.621c.66-1.317 1.101-2.853 1.101-4.39C19.038 4.17 14.853 0 9.676 0 4.5 0 .315 4.17.315 9.327s4.185 9.326 9.361 9.326c1.542 0 3.084-.439 4.406-1.097l3.634 3.621c1.102 1.097 2.754 1.097 3.855 0a2.852 2.852 0 0 0 0-3.84zm-11.895-.878c-3.965 0-7.159-3.182-7.159-7.132 0-3.95 3.194-7.132 7.16-7.132 3.964 0 7.158 3.182 7.158 7.132 0 3.95-3.194 7.132-7.159 7.132z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

SearchIcon.propTypes = propTypes;

export default SearchIcon;
